module.exports = __webpack_public_path__ + "img/padlock.4747c399.png";